"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinitionsByLabel = exports.defaultPropertyDefinitions = exports.STANDARD_SYMBOL_MAPPING = exports.STANDARD_SYMBOL_PIN_MAPPING = exports.partPropertyCategories = exports.copilotContextProperties = exports.unLabeledPartTypes = exports.unlabeledPartCriteria = exports.pinTypeOptions = exports.partTypeAutocompleteOptions = exports.PART_TYPE_DEFINITIONS = exports.portalPartType = exports.deprecatedPartCategoryPropertyKey = exports.defaultPinType = exports.PropertyTypes = exports.PACKAGE_CASE_CODE_DATA = void 0;
exports.getPackageCaseCodeOptions = getPackageCaseCodeOptions;
exports.getPackageCaseCodeOptionsWithPinCounts = getPackageCaseCodeOptionsWithPinCounts;
exports.getPackageCaseCodeOptionsForPartType = getPackageCaseCodeOptionsForPartType;
exports.getPackageFamilies = getPackageFamilies;
exports.getPackageInfo = getPackageInfo;
exports.getPackageFamilyData = getPackageFamilyData;
exports.getDesignatorPrefixForPartType = getDesignatorPrefixForPartType;
exports.getPartTypeForDesignatorPrefix = getPartTypeForDesignatorPrefix;
exports.getPartTypeDefinition = getPartTypeDefinition;
exports.getElectricalPropertyKeysForPartType = getElectricalPropertyKeysForPartType;
exports.isPartUnlabeled = isPartUnlabeled;
exports.getStandardSymbolPartTypes = getStandardSymbolPartTypes;
exports.hasStandardSymbol = hasStandardSymbol;
// TODO afaict, `PropertyTypes` is only used for PropertyTypes.value, to distinguish
// electrical value properties like resistance/capitance/inductance. It'd probably
// be simpler to represent this as a simple flag .isPartValue or something.
const lodash_1 = require("lodash");
const semiconductorManufacturerAliases_1 = require("./semiconductorManufacturerAliases");
/**
 * Master object containing all package case code data organized by family.
 * This is the single source of truth for package codes.
 * Keys are lowercase family identifiers for easy lookup.
 */
exports.PACKAGE_CASE_CODE_DATA = {
    // SOT family - Small Outline Transistor packages
    sot: {
        family: "SOT",
        packages: [
            { name: "SOT-23", pins: 3, commonPartTypes: ["Transistor", "Diode", "LED"] },
            { name: "SOT-23-5", pins: 5, commonPartTypes: ["Transistor", "Linear Regulator", "Integrated Circuit"] },
            { name: "SOT-23-6", pins: 6, commonPartTypes: ["Transistor", "Interface", "Integrated Circuit"] },
            { name: "SOT-23-8", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "SOT-223", pins: 4, commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "SOT-323", pins: 3, commonPartTypes: ["Transistor", "Diode", "LED"] },
            { name: "SOT-363", pins: 6, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "SOT-416", pins: 3, commonPartTypes: ["Transistor", "Diode"] },
            { name: "SOT-666", pins: 6, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "SOT-723", pins: 3, commonPartTypes: ["Transistor", "Diode"] },
            { name: "23-SOT", commonPartTypes: ["Transistor", "Diode", "LED"] },
            { name: "25-SOT", commonPartTypes: ["Transistor", "Diode"] },
            { name: "89-SOT", commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "363-SOT", commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "SOT", commonPartTypes: ["Transistor", "Diode", "LED", "Linear Regulator"] },
        ],
    },
    // TSOT family - Thin Small Outline Transistor
    tsot: {
        family: "TSOT",
        packages: [
            { name: "TSOT-23-6", pins: 6, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "TSOT", commonPartTypes: ["Transistor", "Diode", "LED"] },
        ],
    },
    // SSOT family
    ssot: {
        family: "SSOT",
        packages: [{ name: "24-SSOT", commonPartTypes: ["Transistor", "Integrated Circuit"] }],
    },
    // TO family - Transistor Outline packages
    to: {
        family: "TO",
        packages: [
            { name: "TO-263", pins: 3, commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "92-TO", commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "220-TO", commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "252-TO", commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "PG-TO", commonPartTypes: ["Transistor", "Linear Regulator"] },
            { name: "TO", commonPartTypes: ["Transistor", "Diode", "Linear Regulator"] },
        ],
    },
    // DO family - Diode Outline packages
    do: {
        family: "DO",
        packages: [
            { name: "35-DO", pins: 2, commonPartTypes: ["Diode"] },
            { name: "41-DO", pins: 2, commonPartTypes: ["Diode"] },
            { name: "201-DO", pins: 2, commonPartTypes: ["Diode"] },
            { name: "DO", commonPartTypes: ["Diode"] },
        ],
    },
    // SOD family - Small Outline Diode
    sod: {
        family: "SOD",
        packages: [{ name: "323-SOD", pins: 2, commonPartTypes: ["Diode"] }],
    },
    // USP family
    usp: {
        family: "USP",
        packages: [
            { name: "3-USP", pins: 3, commonPartTypes: ["Transistor", "Diode"] },
            { name: "4-USP", pins: 4, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "4-USPC", pins: 4, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "4-USPN", pins: 4, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "4-USPQ", pins: 4, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "6-USP", pins: 6, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "6-USPC", pins: 6, commonPartTypes: ["Transistor", "Integrated Circuit"] },
            { name: "10-USPC", pins: 10, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // SMD family - Surface Mount Device
    smd: {
        family: "SMD",
        packages: [
            { name: "4-SMD", pins: 4, commonPartTypes: ["Integrated Circuit", "Sensor"] },
            { name: "SMD", commonPartTypes: ["Integrated Circuit", "Sensor"] },
        ],
    },
    // CSMD family
    csmd: {
        family: "CSMD",
        packages: [{ name: "CSMD", commonPartTypes: ["Integrated Circuit"] }],
    },
    // UDFN family - Ultra-thin Dual Flat No-lead
    udfn: {
        family: "UDFN",
        packages: [
            { name: "4-UDFN", pins: 4, commonPartTypes: ["Transistor", "Diode", "Integrated Circuit"] },
            { name: "8-UDFN", pins: 8, commonPartTypes: ["Integrated Circuit", "Linear Regulator"] },
            { name: "10-UDFN", pins: 10, commonPartTypes: ["Integrated Circuit", "Linear Regulator"] },
        ],
    },
    // SO family - Small Outline
    so: {
        family: "SO",
        packages: [
            { name: "4-SO", pins: 4, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "6-SO", pins: 6, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "8-SO", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-SO", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "20-SO", pins: 20, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "SO", commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // DIP family - Dual In-line Package
    dip: {
        family: "DIP",
        packages: [
            { name: "4-DIP", pins: 4, commonPartTypes: ["Integrated Circuit"] },
            { name: "8-DIP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "14-DIP", pins: 14, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-DIP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "18-DIP", pins: 18, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "20-DIP", pins: 20, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "22-DIP", pins: 22, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "24-DIP", pins: 24, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "28-DIP", pins: 28, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "32-DIP", pins: 32, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "40-DIP", pins: 40, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "42-DIP", pins: 42, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "48-DIP", pins: 48, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "DIP", commonPartTypes: ["Integrated Circuit", "Microcontroller", "Interface", "Relay"] },
        ],
    },
    // PDIP family - Plastic Dual In-line Package
    pdip: {
        family: "PDIP",
        packages: [
            { name: "6-PDIP", pins: 6, commonPartTypes: ["Integrated Circuit"] },
            { name: "8-PDIP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "PDIP", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // SMDIP family
    smdip: {
        family: "SMDIP",
        packages: [{ name: "16-SMDIP", pins: 16, commonPartTypes: ["Integrated Circuit"] }],
    },
    // TSSOP family - Thin Shrink Small Outline Package
    tssop: {
        family: "TSSOP",
        packages: [
            { name: "5-TSSOP", pins: 5, commonPartTypes: ["Integrated Circuit"] },
            { name: "6-TSSOP", pins: 6, commonPartTypes: ["Integrated Circuit"] },
            { name: "8-TSSOP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "14-TSSOP", pins: 14, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-TSSOP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "20-TSSOP", pins: 20, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "24-TSSOP", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "28-TSSOP", pins: 28, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "30-TSSOP", pins: 30, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "32-TSSOP", pins: 32, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "38-TSSOP", pins: 38, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "44-TSSOP", pins: 44, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "48-TSSOP", pins: 48, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "50-TSSOP", pins: 50, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "52-TSSOP", pins: 52, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "56-TSSOP", pins: 56, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "64-TSSOP", pins: 64, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "80-TSSOP", pins: 80, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // HTSSOP family - Heat-sink Thin Shrink Small Outline Package
    htssop: {
        family: "HTSSOP",
        packages: [
            { name: "14-HTSSOP", pins: 14, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "20-HTSSOP", pins: 20, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "24-HTSSOP", pins: 24, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "28-HTSSOP", pins: 28, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "32-HTSSOP", pins: 32, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "38-HTSSOP", pins: 38, commonPartTypes: ["Integrated Circuit", "Power Management"] },
            { name: "56-HTSSOP", pins: 56, commonPartTypes: ["Integrated Circuit", "Power Management"] },
        ],
    },
    // ETSSOP family
    etssop: {
        family: "ETSSOP",
        packages: [{ name: "20-ETSSOP", pins: 20, commonPartTypes: ["Integrated Circuit"] }],
    },
    // PLCC family - Plastic Leaded Chip Carrier
    plcc: {
        family: "PLCC",
        packages: [{ name: "6-PLCC", pins: 6, commonPartTypes: ["Integrated Circuit"] }],
    },
    // DFN family - Dual Flat No-lead
    dfn: {
        family: "DFN",
        packages: [
            { name: "6-DFN", pins: 6, commonPartTypes: ["Transistor", "Diode", "Integrated Circuit"] },
            { name: "8-DFN", pins: 8, commonPartTypes: ["Integrated Circuit", "Linear Regulator", "Sensor"] },
            { name: "10-DFN", pins: 10, commonPartTypes: ["Integrated Circuit", "Linear Regulator"] },
            { name: "12-DFN", pins: 12, commonPartTypes: ["Integrated Circuit", "Linear Regulator"] },
            { name: "16-DFN", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "18-DFN", pins: 18, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "22-DFN", pins: 22, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "24-DFN", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // TDFN family - Thin Dual Flat No-lead
    tdfn: {
        family: "TDFN",
        packages: [
            { name: "6-TDFN", pins: 6, commonPartTypes: ["Transistor", "Diode", "Integrated Circuit"] },
            { name: "8-TDFN", pins: 8, commonPartTypes: ["Integrated Circuit", "Linear Regulator"] },
            { name: "10-TDFN", pins: 10, commonPartTypes: ["Integrated Circuit"] },
            { name: "12-TDFN", pins: 12, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // WDFN family - Very Very Thin Dual Flat No-lead
    wdfn: {
        family: "WDFN",
        packages: [
            { name: "6-WDFN", pins: 6, commonPartTypes: ["Transistor", "Diode", "Integrated Circuit"] },
            { name: "8-WDFN", pins: 8, commonPartTypes: ["Integrated Circuit"] },
            { name: "12-WDFN", pins: 12, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // VDFN family
    vdfn: {
        family: "VDFN",
        packages: [{ name: "8-VDFN", pins: 8, commonPartTypes: ["Transistor", "Integrated Circuit"] }],
    },
    // XDFN family
    xdfn: {
        family: "XDFN",
        packages: [{ name: "XDFN", commonPartTypes: ["Integrated Circuit"] }],
    },
    // DSBGA family - Die-Size Ball Grid Array
    dsbga: {
        family: "DSBGA",
        packages: [
            { name: "6-DSBGA", pins: 6, commonPartTypes: ["Integrated Circuit"] },
            { name: "8-DSBGA", pins: 8, commonPartTypes: ["Integrated Circuit"] },
            { name: "9-DSBGA", pins: 9, commonPartTypes: ["Integrated Circuit"] },
            { name: "12-DSBGA", pins: 12, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "49-DSBGA", pins: 49, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "64-DSBGA", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // TSOP family - Thin Small Outline Package
    tsop: {
        family: "TSOP",
        packages: [
            { name: "6-TSOP", pins: 6, commonPartTypes: ["Integrated Circuit"] },
            { name: "TSOP", commonPartTypes: ["Integrated Circuit", "DRAM", "NAND Flash"] },
        ],
    },
    // WSON family - Very Very Thin Small Outline No-lead
    wson: {
        family: "WSON",
        packages: [
            { name: "6-WSON", pins: 6, commonPartTypes: ["Integrated Circuit"] },
            { name: "8-WSON", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "10-WSON", pins: 10, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "14-WSON", pins: 14, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-WSON", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // PowerSMD family
    powersmd: {
        family: "PowerSMD",
        packages: [
            { name: "7-PowerSMD", pins: 7, commonPartTypes: ["Transistor", "Linear Regulator", "Power Management"] },
        ],
    },
    // LGA family - Land Grid Array
    lga: {
        family: "LGA",
        packages: [
            { name: "8-LGA", pins: 8, commonPartTypes: ["Sensor", "Integrated Circuit"] },
            { name: "12-LGA", pins: 12, commonPartTypes: ["Sensor", "Integrated Circuit"] },
            { name: "14-LGA", pins: 14, commonPartTypes: ["Sensor", "Integrated Circuit"] },
            { name: "16-LGA", pins: 16, commonPartTypes: ["Sensor", "Integrated Circuit"] },
            { name: "24-LGA", pins: 24, commonPartTypes: ["Sensor", "Integrated Circuit", "Microcontroller"] },
            { name: "28-LGA", pins: 28, commonPartTypes: ["Sensor", "Integrated Circuit", "Microcontroller"] },
            { name: "LGA", commonPartTypes: ["Sensor", "Integrated Circuit", "Microcontroller"] },
        ],
    },
    // MSOP family - Mini Small Outline Package
    msop: {
        family: "MSOP",
        packages: [
            {
                name: "8-MSOP",
                pins: 8,
                commonPartTypes: ["Integrated Circuit", "Interface", "Operational Amplifier (OP-AMP)"],
            },
            { name: "10-MSOP", pins: 10, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "12-MSOP", pins: 12, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-MSOP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "MSOP", commonPartTypes: ["Integrated Circuit", "Interface", "Operational Amplifier (OP-AMP)"] },
        ],
    },
    // SIP family - Single In-line Package
    sip: {
        family: "SIP",
        packages: [
            { name: "8-SIP", pins: 8, commonPartTypes: ["Integrated Circuit", "Resistor"] },
            { name: "9-SIP", pins: 9, commonPartTypes: ["Integrated Circuit", "Resistor"] },
        ],
    },
    // SOIC family - Small Outline Integrated Circuit
    soic: {
        family: "SOIC",
        packages: [
            {
                name: "8-SOIC",
                pins: 8,
                commonPartTypes: ["Integrated Circuit", "Interface", "Operational Amplifier (OP-AMP)"],
            },
            { name: "14-SOIC", pins: 14, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-SOIC", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "18-SOIC", pins: 18, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "20-SOIC", pins: 20, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "24-SOIC", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "28-SOIC", pins: 28, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
        ],
    },
    // SOP family - Small Outline Package
    sop: {
        family: "SOP",
        packages: [
            { name: "8-SOP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-SOP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "18-SOP", pins: 18, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // SSOP family - Shrink Small Outline Package
    ssop: {
        family: "SSOP",
        packages: [
            { name: "8-SSOP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "16-SSOP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "18-SSOP", pins: 18, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "20-SSOP", pins: 20, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "24-SSOP", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "28-SSOP", pins: 28, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "32-SSOP", pins: 32, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "44-SSOP", pins: 44, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "48-SSOP", pins: 48, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "56-SSOP", pins: 56, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "SSOP", commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // VSSOP family - Very Shrink Small Outline Package
    vssop: {
        family: "VSSOP",
        packages: [
            { name: "8-VSSOP", pins: 8, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "10-VSSOP", pins: 10, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // HVSSOP family
    hvssop: {
        family: "HVSSOP",
        packages: [{ name: "10-HVSSOP", pins: 10, commonPartTypes: ["Integrated Circuit"] }],
    },
    // VSON family
    vson: {
        family: "VSON",
        packages: [{ name: "10-VSON", pins: 10, commonPartTypes: ["Integrated Circuit"] }],
    },
    // USON family
    uson: {
        family: "USON",
        packages: [
            { name: "10-USON", pins: 10, commonPartTypes: ["Integrated Circuit"] },
            { name: "20-USON", pins: 20, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // QFN family - Quad Flat No-lead
    qfn: {
        family: "QFN",
        packages: [
            { name: "12-QFN", pins: 12, commonPartTypes: ["Integrated Circuit", "Sensor"] },
            { name: "16-QFN", pins: 16, commonPartTypes: ["Integrated Circuit", "Sensor", "Linear Regulator"] },
            { name: "20-QFN", pins: 20, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "24-QFN", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "28-QFN", pins: 28, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "32-QFN", pins: 32, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "36-QFN", pins: 36, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "38-QFN", pins: 38, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "40-QFN", pins: 40, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "42-QFN", pins: 42, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "44-QFN", pins: 44, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "48-QFN", pins: 48, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "52-QFN", pins: 52, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "56-QFN", pins: 56, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "64-QFN", pins: 64, commonPartTypes: ["Integrated Circuit", "Interface", "Microcontroller"] },
            { name: "68-QFN", pins: 68, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "76-QFN", pins: 76, commonPartTypes: ["Integrated Circuit", "Interface"] },
            {
                name: "QFN",
                commonPartTypes: ["Integrated Circuit", "Microcontroller", "Interface", "Sensor", "Linear Regulator"],
            },
        ],
    },
    // VQFN family - Very Thin Quad Flat No-lead
    vqfn: {
        family: "VQFN",
        packages: [
            { name: "16-VQFN", pins: 16, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "20-VQFN", pins: 20, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "24-VQFN", pins: 24, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "28-VQFN", pins: 28, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "32-VQFN", pins: 32, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "VQFN", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // WQFN family
    wqfn: {
        family: "WQFN",
        packages: [
            { name: "14-WQFN", pins: 14, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "16-WQFN", pins: 16, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "20-WQFN", pins: 20, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "24-WQFN", pins: 24, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "32-WQFN", pins: 32, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "WQFN", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // WFQFN family
    wfqfn: {
        family: "WFQFN",
        packages: [{ name: "WFQFN", commonPartTypes: ["Integrated Circuit"] }],
    },
    // TQFN family - Thin Quad Flat No-lead
    tqfn: {
        family: "TQFN",
        packages: [
            { name: "20-TQFN", pins: 20, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "24-TQFN", pins: 24, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "TQFN", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // UQFN family - Ultra-thin Quad Flat No-lead
    uqfn: {
        family: "UQFN",
        packages: [
            { name: "16-UQFN", pins: 16, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "20-UQFN", pins: 20, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "28-UQFN", pins: 28, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "40-UQFN", pins: 40, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "48-UQFN", pins: 48, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // HVQFN family
    hvqfn: {
        family: "HVQFN",
        packages: [
            { name: "24-HVQFN", pins: 24, commonPartTypes: ["Integrated Circuit"] },
            { name: "32-HVQFN", pins: 32, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // VFQFN family
    vfqfn: {
        family: "VFQFN",
        packages: [{ name: "73-VFQFN", pins: 73, commonPartTypes: ["Integrated Circuit"] }],
    },
    // WLP family - Wafer Level Package
    wlp: {
        family: "WLP",
        packages: [
            { name: "15-WLP", pins: 15, commonPartTypes: ["Integrated Circuit", "Sensor"] },
            { name: "16-WLP", pins: 16, commonPartTypes: ["Integrated Circuit", "Sensor"] },
        ],
    },
    // WLCSP family - Wafer Level Chip Scale Package
    wlcsp: {
        family: "WLCSP",
        packages: [{ name: "WLCSP", commonPartTypes: ["Integrated Circuit", "Sensor"] }],
    },
    // QSOP family - Quarter-size Small Outline Package
    qsop: {
        family: "QSOP",
        packages: [
            { name: "16-QSOP", pins: 16, commonPartTypes: ["Integrated Circuit", "Interface"] },
            { name: "24-QSOP", pins: 24, commonPartTypes: ["Integrated Circuit", "Interface"] },
        ],
    },
    // MLPQ family
    mlpq: {
        family: "MLPQ",
        packages: [
            { name: "16-MLPQ", pins: 16, commonPartTypes: ["Integrated Circuit"] },
            { name: "20-MLPQ", pins: 20, commonPartTypes: ["Integrated Circuit"] },
        ],
    },
    // MLF family - Micro Lead Frame
    mlf: {
        family: "MLF",
        packages: [{ name: "20-MLF", pins: 20, commonPartTypes: ["Integrated Circuit"] }],
    },
    // BGA family - Ball Grid Array
    bga: {
        family: "BGA",
        packages: [
            { name: "16-BGA", pins: 16, commonPartTypes: ["Integrated Circuit"] },
            { name: "25-BGA", pins: 25, commonPartTypes: ["Integrated Circuit"] },
            { name: "36-BGA", pins: 36, commonPartTypes: ["Integrated Circuit"] },
            { name: "48-BGA", pins: 48, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "64-BGA", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "68-BGA", pins: 68, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "81-BGA", pins: 81, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "88-BGA", pins: 88, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "90-BGA", pins: 90, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "96-BGA", pins: 96, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "256-BGA", pins: 256, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "289-BGA", pins: 289, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "324-BGA", pins: 324, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "672-BGA", pins: 672, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "BGA", commonPartTypes: ["Integrated Circuit", "Microcontroller", "FPGA", "Processor", "DRAM"] },
        ],
    },
    // FBGA family - Fine-pitch Ball Grid Array
    fbga: {
        family: "FBGA",
        packages: [
            { name: "78-FBGA", pins: 78, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "153-FBGA", pins: 153, commonPartTypes: ["Integrated Circuit", "Microcontroller", "DRAM"] },
            { name: "216-FBGA", pins: 216, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "256-FBGA", pins: 256, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "320-FBGA", pins: 320, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "400-FBGA", pins: 400, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "456-FBGA", pins: 456, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "676-FBGA", pins: 676, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "FBGA", commonPartTypes: ["Integrated Circuit", "Microcontroller", "FPGA", "Processor", "DRAM"] },
        ],
    },
    // TFBGA family - Thin Fine-pitch Ball Grid Array
    tfbga: {
        family: "TFBGA",
        packages: [
            { name: "64-TFBGA", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "100-TFBGA", pins: 100, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "TFBGA", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // VFBGA family - Very Fine-pitch Ball Grid Array
    vfbga: {
        family: "VFBGA",
        packages: [
            { name: "49-VFBGA", pins: 49, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "400-VFBGA", pins: 400, commonPartTypes: ["Integrated Circuit", "FPGA", "Processor"] },
            { name: "VFBGA", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // UFBGA family - Ultra Fine-pitch Ball Grid Array
    ufbga: {
        family: "UFBGA",
        packages: [
            { name: "64-UFBGA", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "UFBGA", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // FPBGA family
    fpbga: {
        family: "FPBGA",
        packages: [
            { name: "256-FPBGA", pins: 256, commonPartTypes: ["FPGA", "Processor"] },
            { name: "484-FPBGA", pins: 484, commonPartTypes: ["FPGA", "Processor"] },
        ],
    },
    // FTBGA family
    ftbga: {
        family: "FTBGA",
        packages: [{ name: "256-FTBGA", pins: 256, commonPartTypes: ["FPGA", "Processor"] }],
    },
    // CABGA family - Chip Array Ball Grid Array
    cabga: {
        family: "CABGA",
        packages: [
            { name: "256-CABGA", pins: 256, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "CABGA", commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // CSFBGA family
    csfbga: {
        family: "CSFBGA",
        packages: [{ name: "285-CSFBGA", pins: 285, commonPartTypes: ["Integrated Circuit"] }],
    },
    // FCBGA family - Flip Chip Ball Grid Array
    fcbga: {
        family: "FCBGA",
        packages: [
            { name: "324-FCBGA", pins: 324, commonPartTypes: ["FPGA", "Processor"] },
            { name: "363-FCBGA", pins: 363, commonPartTypes: ["FPGA", "Processor"] },
            { name: "676-FCBGA", pins: 676, commonPartTypes: ["FPGA", "Processor"] },
        ],
    },
    // UCBGA family
    ucbga: {
        family: "UCBGA",
        packages: [{ name: "81-UCBGA", pins: 81, commonPartTypes: ["Integrated Circuit"] }],
    },
    // LBGA family
    lbga: {
        family: "LBGA",
        packages: [{ name: "LBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // VBGA family
    vbga: {
        family: "VBGA",
        packages: [{ name: "VBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // CSPBGA family
    cspbga: {
        family: "CSPBGA",
        packages: [{ name: "CSPBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // CSBGA family
    csbga: {
        family: "CSBGA",
        packages: [{ name: "CSBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // UBGA family
    ubga: {
        family: "UBGA",
        packages: [{ name: "UBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // PBGA family
    pbga: {
        family: "PBGA",
        packages: [{ name: "PBGA", commonPartTypes: ["Integrated Circuit", "Processor"] }],
    },
    // MBGA family
    mbga: {
        family: "MBGA",
        packages: [{ name: "MBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // LFBGA family
    lfbga: {
        family: "LFBGA",
        packages: [{ name: "LFBGA", commonPartTypes: ["Integrated Circuit"] }],
    },
    // FPGA family
    fpga: {
        family: "FPGA",
        packages: [{ name: "FPGA", commonPartTypes: ["FPGA"] }],
    },
    // LQFP family - Low-profile Quad Flat Package
    lqfp: {
        family: "LQFP",
        packages: [
            { name: "32-LQFP", pins: 32, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "44-LQFP", pins: 44, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "48-LQFP", pins: 48, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "52-LQFP", pins: 52, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "64-LQFP", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "80-LQFP", pins: 80, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "100-LQFP", pins: 100, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "144-LQFP", pins: 144, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "176-LQFP", pins: 176, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "208-LQFP", pins: 208, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "216-LQFP", pins: 216, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "LQFP", commonPartTypes: ["Integrated Circuit", "Microcontroller", "Interface"] },
        ],
    },
    // TQFP family - Thin Quad Flat Package
    tqfp: {
        family: "TQFP",
        packages: [
            { name: "32-TQFP", pins: 32, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "44-TQFP", pins: 44, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "48-TQFP", pins: 48, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "52-TQFP", pins: 52, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "64-TQFP", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "80-TQFP", pins: 80, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "100-TQFP", pins: 100, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
            { name: "144-TQFP", pins: 144, commonPartTypes: ["Integrated Circuit", "Microcontroller"] },
        ],
    },
    // HTQFP family
    htqfp: {
        family: "HTQFP",
        packages: [{ name: "64-HTQFP", pins: 64, commonPartTypes: ["Integrated Circuit", "Microcontroller"] }],
    },
    // PQFP family - Plastic Quad Flat Package
    pqfp: {
        family: "PQFP",
        packages: [
            { name: "44-PQFP", pins: 44, commonPartTypes: ["Integrated Circuit", "Processor"] },
            { name: "80-PQFP", pins: 80, commonPartTypes: ["Integrated Circuit", "Processor"] },
            { name: "100-PQFP", pins: 100, commonPartTypes: ["Integrated Circuit", "Processor"] },
        ],
    },
    // VQFP family - Very Thin Quad Flat Package
    vqfp: {
        family: "VQFP",
        packages: [
            { name: "80-VQFP", pins: 80, commonPartTypes: ["Integrated Circuit", "Processor"] },
            { name: "100-VQFP", pins: 100, commonPartTypes: ["Integrated Circuit", "Processor"] },
        ],
    },
    // EQFP family
    eqfp: {
        family: "EQFP",
        packages: [{ name: "144-EQFP", pins: 144, commonPartTypes: ["Integrated Circuit"] }],
    },
    // HLQFP family
    hlqfp: {
        family: "HLQFP",
        packages: [{ name: "HLQFP", commonPartTypes: ["Integrated Circuit"] }],
    },
    // QFP family - Quad Flat Package
    qfp: {
        family: "QFP",
        packages: [{ name: "QFP", commonPartTypes: ["Integrated Circuit", "Microcontroller"] }],
    },
    // LFCSP family
    lfcsp: {
        family: "LFCSP",
        packages: [{ name: "LFCSP", commonPartTypes: ["Integrated Circuit"] }],
    },
    // FCCSP family
    fccsp: {
        family: "FCCSP",
        packages: [{ name: "FCCSP", commonPartTypes: ["Integrated Circuit"] }],
    },
    // SOJ family - Small Outline J-lead
    soj: {
        family: "SOJ",
        packages: [{ name: "36-SOJ", pins: 36, commonPartTypes: ["DRAM", "Integrated Circuit"] }],
    },
    // VSOP family - Very Small Outline Package
    vsop: {
        family: "VSOP",
        packages: [{ name: "40-VSOP", pins: 40, commonPartTypes: ["Integrated Circuit"] }],
    },
    // VSO family
    vso: {
        family: "VSO",
        packages: [{ name: "56-VSO", pins: 56, commonPartTypes: ["Integrated Circuit"] }],
    },
    // BPX family
    bpx: {
        family: "BPX",
        packages: [{ name: "61-BPX", pins: 61, commonPartTypes: ["Integrated Circuit"] }],
    },
    // R family - Resistor packages
    r: {
        family: "R",
        packages: [
            { name: "6-R", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_0201_0603Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_0402_1005Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_0603_1608Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_0805_2012Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_1206_3216Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_1210_3225Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_1806_4516Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_1812_4532Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_2010_5025Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_2512_6332Metric", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_POT_PV36P", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "R_POT_PV36W", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "R_POT_PV36X", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "R_POT_PV36Y", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "R_POT_PV36Z", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "R_AXIAL_724W46L381D178B", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_AXIAL_1176W63L850D250B", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "R_AXIAL_Vertical", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
        ],
    },
    // C family - Capacitor packages
    c: {
        family: "C",
        packages: [
            { name: "C_0402_1005Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_0603_1608Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_0805_2012Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_1206_3216Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_1210_3225Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_1812_4532Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
            { name: "C_1825_4564Metric", pins: 2, commonPartTypes: ["Ceramic Capacitor", "Non-Polarized Capacitor"] },
        ],
    },
    // CP family - Polarized Capacitor packages
    cp: {
        family: "CP",
        packages: [
            { name: "CP_3216-18_Kemet-A", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "CP_3528-21_Kemet-B", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "CP_6032-28_Kemet-C", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "CP_7343-31_Kemet-D", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
        ],
    },
    // CPOL family - Polarized Capacitor packages
    cpol: {
        family: "CPOL",
        packages: [
            { name: "CPOL_830X1050Metric", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "CPOL_1030X1050Metric", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "CPOL_1905X1660Metric", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
        ],
    },
    // D family - Diode packages
    d: {
        family: "D",
        packages: [
            { name: "D_0603_1608Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_0805_2012Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_1206_3216Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_2010_5025Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_2114_3652Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_3220_8050Metric", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_MELF", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_MicroMELF", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_MiniMELF", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_PowerDI-123", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SC-80", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SMA", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SMB", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SMC", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-110", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-123", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-123F", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-323", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-323F", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_SOD-523", pins: 2, commonPartTypes: ["Diode"] },
            { name: "D_TUMD2", pins: 2, commonPartTypes: ["Diode"] },
        ],
    },
    // L family - Inductor packages
    l: {
        family: "L",
        packages: [
            { name: "L_0201_0603Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_0402_1005Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_0603_1608Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_0805_2012Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_1206_3216Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_1210_3225Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_1806_4516Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_1812_4532Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_2010_5025Metric", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "L_2512_6332Metric", pins: 2, commonPartTypes: ["Inductor"] },
        ],
    },
    // MODULE family
    module: {
        family: "MODULE",
        packages: [
            { name: "MODULE_WEMOS_D1_MINI", commonPartTypes: ["Microcontroller", "Integrated Circuit"] },
            { name: "Module", commonPartTypes: ["Microcontroller", "Integrated Circuit", "RF Transceiver"] },
            { name: "ESP32-S2-WROVER", commonPartTypes: ["Microcontroller", "RF Transceiver"] },
        ],
    },
    // DISP family - Display packages
    disp: {
        family: "DISP",
        packages: [{ name: "DISP_7SEG_10DIP", pins: 10, commonPartTypes: ["Display Device"] }],
    },
    // USB family
    usb: {
        family: "USB",
        packages: [
            { name: "male_ufl_connector", commonPartTypes: ["Connector"] },
            { name: "usb_micro_female", pins: 5, commonPartTypes: ["Connector"] },
            { name: "usb_mini_female", pins: 5, commonPartTypes: ["Connector"] },
            { name: "usb_a_type_female", pins: 4, commonPartTypes: ["Connector"] },
            { name: "usb_a_type_female_double_stack", pins: 8, commonPartTypes: ["Connector"] },
            { name: "USB-SMD", commonPartTypes: ["Connector"] },
        ],
    },
    // TH family - Through-hole packages
    th: {
        family: "TH",
        packages: [
            { name: "CAP-TH", pins: 2, commonPartTypes: ["Polarized Capacitor", "Electrolytic Capacitor"] },
            { name: "LED-TH", pins: 2, commonPartTypes: ["LED"] },
            { name: "RES-TH", pins: 2, commonPartTypes: ["Resistor", "Fixed Resistor"] },
            { name: "RES-ADJ-TH", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "DIO-TH", pins: 2, commonPartTypes: ["Diode"] },
            { name: "FUSE-TH", pins: 2, commonPartTypes: ["Protection"] },
            { name: "CONN-TH", commonPartTypes: ["Connector"] },
            { name: "IND-TH", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "RELAY-TH", commonPartTypes: ["Relay"] },
        ],
    },
    // SMD component family
    smdcomponent: {
        family: "SMD-Component",
        packages: [
            { name: "RES-ARRAY-SMD", commonPartTypes: ["Resistor"] },
            { name: "RES-ADJ-SMD", pins: 3, commonPartTypes: ["Resistor", "Variable Resistor"] },
            { name: "KEY-SMD", commonPartTypes: ["Switch"] },
            { name: "SW-SMD", commonPartTypes: ["Switch"] },
            { name: "OSC-SMD", pins: 4, commonPartTypes: ["Oscillator"] },
            { name: "CRYSTAL-SMD", pins: 2, commonPartTypes: ["Oscillator"] },
            { name: "CONN-SMD", commonPartTypes: ["Connector"] },
            { name: "IND-SMD", pins: 2, commonPartTypes: ["Inductor"] },
            { name: "PWRM-SMD", commonPartTypes: ["Power Management"] },
            { name: "PCIE-SMD", commonPartTypes: ["Connector"] },
            { name: "OLED-SMD_UG", commonPartTypes: ["Display Device"] },
        ],
    },
    // MELF family
    melf: {
        family: "MELF",
        packages: [{ name: "SQ-MELF", pins: 2, commonPartTypes: ["Diode", "Resistor"] }],
    },
    // P600 family
    p600: {
        family: "P600",
        packages: [{ name: "P600", pins: 2, commonPartTypes: ["Diode"] }],
    },
    // SMC family
    smc: {
        family: "SMC",
        packages: [{ name: "SMC", pins: 2, commonPartTypes: ["Diode"] }],
    },
    // PLAD family
    plad: {
        family: "PLAD",
        packages: [{ name: "PLAD", commonPartTypes: ["Integrated Circuit"] }],
    },
    // POWERDI family
    powerdi: {
        family: "POWERDI",
        packages: [{ name: "POWERDI", commonPartTypes: ["Diode", "Transistor"] }],
    },
    // POWERDIP family
    powerdip: {
        family: "POWERDIP",
        packages: [{ name: "POWERDIP", commonPartTypes: ["Integrated Circuit", "Power Management"] }],
    },
    // POWERVDFN family
    powervdfn: {
        family: "POWERVDFN",
        packages: [{ name: "POWERVDFN", commonPartTypes: ["Transistor", "Power Management"] }],
    },
    // FLIPCHIP family
    flipchip: {
        family: "FLIPCHIP",
        packages: [{ name: "FLIPCHIP", commonPartTypes: ["Integrated Circuit"] }],
    },
    // DIN family
    din: {
        family: "DIN",
        packages: [{ name: "DIN", commonPartTypes: ["Connector"] }],
    },
    // XCVR family
    xcvr: {
        family: "XCVR",
        packages: [{ name: "XCVR", commonPartTypes: ["RF Transceiver"] }],
    },
    // CMWX family
    cmwx: {
        family: "CMWX",
        packages: [{ name: "CMWX", commonPartTypes: ["RF Transceiver"] }],
    },
    // RHDR family
    rhdr: {
        family: "RHDR",
        packages: [{ name: "RHDR", commonPartTypes: ["Connector"] }],
    },
    // D2PAK family
    d2pak: {
        family: "D2PAK",
        packages: [{ name: "D2PAK", pins: 3, commonPartTypes: ["Transistor", "Linear Regulator"] }],
    },
};
/**
 * Gets all package case code options from PACKAGE_CASE_CODE_DATA.
 * Packages are sorted by family name first, then by pin count within each family.
 * This produces a more intuitive ordering for users browsing packages:
 * - Family name first (e.g., "MSOP")
 * - Then variants with pin counts sorted numerically (e.g., "8-MSOP", "10-MSOP")
 * - Then move to the next family alphabetically
 */
function getPackageCaseCodeOptions() {
    const options = [];
    // Get families sorted alphabetically
    const families = Object.values(exports.PACKAGE_CASE_CODE_DATA).sort((a, b) => a.family.localeCompare(b.family));
    for (const familyData of families) {
        // Check if family name exists as a standalone package
        const familyPackage = familyData.packages.find((pkg) => pkg.name === familyData.family);
        if (familyPackage) {
            options.push(familyPackage.name);
        }
        // Sort packages by pin count (numerically), then by name
        const sortedPackages = familyData.packages
            .filter((pkg) => pkg.name !== familyData.family) // Exclude the family package we already added
            .sort((a, b) => {
            // Extract pin count for sorting
            const aPins = a.pins ?? 0;
            const bPins = b.pins ?? 0;
            return aPins - bPins;
        });
        options.push(...sortedPackages.map((pkg) => pkg.name));
    }
    return options;
}
/**
 * Gets package case code options with only specific packages that have pin counts.
 * This excludes generic package families (like "BGA", "FBGA", "QFN") that don't have specific pin counts.
 * Use this for the part creation wizard dropdown where specific packages are needed.
 */
function getPackageCaseCodeOptionsWithPinCounts() {
    const options = [];
    // Get families sorted alphabetically
    const families = Object.values(exports.PACKAGE_CASE_CODE_DATA).sort((a, b) => a.family.localeCompare(b.family));
    for (const familyData of families) {
        // Sort packages by pin count (numerically), only include packages with defined pin counts
        // This excludes package families (like "BGA", "FBGA") that don't have specific pin counts
        const sortedPackages = familyData.packages
            .filter((pkg) => pkg.pins !== undefined) // Only include packages with defined pin counts
            .sort((a, b) => {
            const aPins = a.pins ?? 0;
            const bPins = b.pins ?? 0;
            return aPins - bPins;
        });
        options.push(...sortedPackages.map((pkg) => pkg.name));
    }
    return options;
}
/**
 * Gets package case code options filtered by part type, excluding generic package families.
 * Returns only specific packages (with pin counts) that are commonly used for the specified part type.
 * If no part type is provided, or if the part type has no associated packages,
 * returns all specific packages (with pin counts).
 * This is intended for the part creation wizard dropdown.
 * @param partType - The part type to filter by (e.g., "Resistor", "Transistor", "Integrated Circuit")
 * @returns Array of package code names that match the part type
 */
function getPackageCaseCodeOptionsForPartType(partType) {
    if (!partType) {
        return getPackageCaseCodeOptionsWithPinCounts();
    }
    const options = [];
    const families = Object.values(exports.PACKAGE_CASE_CODE_DATA).sort((a, b) => a.family.localeCompare(b.family));
    for (const familyData of families) {
        // Only include packages with defined pin counts that match the part type
        // This excludes package families (like "BGA", "FBGA") that don't have specific pin counts
        const sortedPackages = familyData.packages
            .filter((pkg) => pkg.pins !== undefined && pkg.commonPartTypes.includes(partType))
            .sort((a, b) => {
            const aPins = a.pins ?? 0;
            const bPins = b.pins ?? 0;
            return aPins - bPins;
        });
        options.push(...sortedPackages.map((pkg) => pkg.name));
    }
    // If no packages match the part type, return all specific packages as fallback
    // This handles part types like Antenna, Ground, Ethernet, etc. that don't have specific packages
    if (options.length === 0) {
        return getPackageCaseCodeOptionsWithPinCounts();
    }
    return options;
}
/**
 * Gets all package family names.
 */
function getPackageFamilies() {
    return Object.values(exports.PACKAGE_CASE_CODE_DATA).map((data) => data.family);
}
/**
 * Gets the package info for a given package code.
 * Returns undefined if the package code is not found.
 */
function getPackageInfo(packageCode) {
    const normalizedCode = packageCode.toUpperCase();
    for (const familyData of Object.values(exports.PACKAGE_CASE_CODE_DATA)) {
        for (const pkg of familyData.packages) {
            if (pkg.name.toUpperCase() === normalizedCode) {
                return pkg;
            }
        }
    }
    return undefined;
}
/**
 * Gets the family data for a given package code.
 * Returns undefined if the package code is not found.
 */
function getPackageFamilyData(packageCode) {
    const normalizedCode = packageCode.toUpperCase();
    for (const familyData of Object.values(exports.PACKAGE_CASE_CODE_DATA)) {
        for (const pkg of familyData.packages) {
            if (pkg.name.toUpperCase() === normalizedCode) {
                return familyData;
            }
        }
    }
    return undefined;
}
var PropertyTypes;
(function (PropertyTypes) {
    PropertyTypes["value"] = "value";
    PropertyTypes["symbolPinPosition"] = "symbol_pin_position";
    PropertyTypes["pinNumber"] = "pinNumber";
})(PropertyTypes || (exports.PropertyTypes = PropertyTypes = {}));
exports.defaultPinType = "Unspecified";
exports.deprecatedPartCategoryPropertyKey = "category";
exports.portalPartType = "Portal";
/**
 * Single source of truth for all built-in part types and their metadata.
 * NOTE: these part types can be considered to be the "built-in" part types of
 * Flux and should not be changed once added. They are used for JEP30 export,
 * simulation model selection, designator prefix assignment, and datasheet importing.
 *
 * Designator prefixes are based on IEEE 315 / IEC 60617 standard reference designators:
 * - U: Integrated circuits, microcontrollers, processors, memory
 * - R: Resistors (fixed and variable)
 * - C: Capacitors (all types)
 * - L: Inductors
 * - D: Diodes, LEDs
 * - Q: Transistors
 * - J: Connectors (jacks/receptacles)
 * - K: Relays
 * - Y: Oscillators, crystals
 * - F: Fuses, protection devices
 * - FL: Filters
 * - T: Transformers, terminals
 * - S: Switches
 * - E: Antennas
 * - DS: Display devices
 * - M: Mechanical parts
 * - PS: Power sources
 * - ISO: Isolators
 * - MR: Memristors
 */
exports.PART_TYPE_DEFINITIONS = {
    Antenna: { designatorPrefix: "E" },
    "Ceramic Capacitor": {
        designatorPrefix: "C",
        parentType: "Non-Polarized Capacitor",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    Connector: { designatorPrefix: "J" },
    Diode: {
        designatorPrefix: "D",
        electricalProperties: ["forward_voltage", "reverse_voltage", "current_rating", "diode_type"],
    },
    "Display Device": { designatorPrefix: "DS" },
    DRAM: { designatorPrefix: "U", parentType: "Integrated Circuit" },
    "Electrolytic Capacitor": {
        designatorPrefix: "C",
        parentType: "Polarized Capacitor",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    Ethernet: { designatorPrefix: "J" },
    "Film Capacitor": {
        designatorPrefix: "C",
        parentType: "Non-Polarized Capacitor",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    Filter: {
        designatorPrefix: "FL",
        electricalProperties: ["controlled_impedance", "frequency"],
    },
    "Fixed Resistor": {
        designatorPrefix: "R",
        parentType: "Resistor",
        electricalProperties: ["resistance", "tolerance", "power_rating"],
    },
    FPGA: { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Ground: { designatorPrefix: "GND" },
    Inductor: {
        designatorPrefix: "L",
        electricalProperties: ["inductance", "current_rating", "tolerance"],
    },
    "Integrated Circuit": { designatorPrefix: "U" },
    Interface: { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Isolator: { designatorPrefix: "ISO" },
    LED: {
        designatorPrefix: "D",
        electricalProperties: ["forward_voltage", "reverse_voltage", "current_rating"],
    },
    "Linear Regulator": { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Mechanical: { designatorPrefix: "M" },
    Memristor: { designatorPrefix: "MR" },
    Microcontroller: { designatorPrefix: "U" },
    "NAND Flash": { designatorPrefix: "U", parentType: "Integrated Circuit" },
    "Non-Polarized Capacitor": {
        designatorPrefix: "C",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    "Operational Amplifier (OP-AMP)": { designatorPrefix: "U" },
    Oscillator: {
        designatorPrefix: "Y",
        electricalProperties: ["frequency"],
    },
    "Polarized Capacitor": {
        designatorPrefix: "C",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    Portal: { designatorPrefix: "P" },
    "Power Management": { designatorPrefix: "U" },
    "Power Source": { designatorPrefix: "PS" },
    Processor: { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Protection: {
        designatorPrefix: "F",
        electricalProperties: ["current_rating", "voltage_rating"],
    },
    pSRAM: { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Relay: { designatorPrefix: "K" },
    Resistor: {
        designatorPrefix: "R",
        electricalProperties: ["resistance", "tolerance", "power_rating"],
    },
    "RF Transceiver": { designatorPrefix: "U", parentType: "Integrated Circuit" },
    Sensor: {
        designatorPrefix: "U",
        electricalProperties: ["resistance", "beta"],
    },
    "Silicon Capacitor": {
        designatorPrefix: "C",
        parentType: "Non-Polarized Capacitor",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    "Super-cap Capacitor": {
        designatorPrefix: "C",
        parentType: "Polarized Capacitor",
        electricalProperties: ["capacitance", "voltage_rating", "tolerance"],
    },
    Switch: { designatorPrefix: "S" },
    Terminal: { designatorPrefix: "T" },
    Transformer: { designatorPrefix: "T" },
    Transistor: {
        designatorPrefix: "Q",
        electricalProperties: ["transistor_type", "drain_to_source_voltage", "continuous_drain_current"],
    },
    "USB C": { designatorPrefix: "J", parentType: "Integrated Circuit" },
    "Variable Resistor": {
        designatorPrefix: "R",
        parentType: "Resistor",
        electricalProperties: ["resistance", "tolerance", "power_rating"],
    },
};
/**
 * Array of all part type names, derived from PART_TYPE_DEFINITIONS.
 * Maintained for backward compatibility with existing code.
 */
exports.partTypeAutocompleteOptions = Object.keys(exports.PART_TYPE_DEFINITIONS);
/**
 * Gets the designator prefix for a given part type.
 * Returns empty string if the part type is not found.
 */
function getDesignatorPrefixForPartType(partType) {
    if (partType in exports.PART_TYPE_DEFINITIONS) {
        return exports.PART_TYPE_DEFINITIONS[partType].designatorPrefix;
    }
    return "";
}
/**
 * Gets the part type for a given designator prefix.
 * Returns undefined if no part type with the given prefix is found.
 * Note: If multiple part types share the same prefix, returns the first match found.
 */
function getPartTypeForDesignatorPrefix(designatorPrefix) {
    for (const partType of exports.partTypeAutocompleteOptions) {
        if (exports.PART_TYPE_DEFINITIONS[partType].designatorPrefix === designatorPrefix) {
            return partType;
        }
    }
    return undefined;
}
/**
 * Gets the full definition for a given part type.
 * Returns undefined if the part type is not found.
 */
function getPartTypeDefinition(partType) {
    if (partType in exports.PART_TYPE_DEFINITIONS) {
        return exports.PART_TYPE_DEFINITIONS[partType];
    }
    return undefined;
}
/**
 * Gets the electrical property keys for a given part type.
 * Returns an empty array if the part type has no electrical properties defined.
 */
function getElectricalPropertyKeysForPartType(partType) {
    const definition = getPartTypeDefinition(partType);
    if (!definition?.electricalProperties) {
        return [];
    }
    return definition.electricalProperties;
}
exports.pinTypeOptions = [
    "Bi-Directional",
    "Digital",
    "Ground",
    "Input",
    "Not Connected",
    "Open Collector",
    "Open Emitter",
    "Output",
    "Passive",
    "Power In",
    "Power Out",
    "Programmable",
    "Reserved",
    "Signal",
    "Tri-State",
    exports.defaultPinType,
];
/**
 * Criteria for parts that do not show pin labels in the schematic editor.
 * A part is unlabeled if it matches ANY criterion in this array.
 *
 * Note: In Flux, multi-passive packages, e.g. three resistors in a DIP have the
 * same part type as an individual instance of that passive, this is why we only
 * hide pin labels for parts of those types if they have exactly 2 pins.
 *
 * We require custom symbols in cases where the typical symbol for such a part
 * conveyes a crucial  difference between the pins (e.g. diodes, polarized caps).
 * This does not guarantee correctness of the symbol, but it provides a good rule
 * of thumb to avoid hiding labels when there is *no evidence* the symbol might
 * be providing the needed info.
 *
 */
exports.unlabeledPartCriteria = [
    { partType: "Ground", pinCount: 1 },
    { partType: "Portal", pinCount: 1 },
    { partType: "Antenna", pinCount: 1 },
    { partType: "Mechanical" },
    { partType: "Filter", pinCount: 2 },
    { partType: "Inductor", pinCount: 2 },
    { partType: "Isolator", pinCount: 2 },
    { partType: "Diode", pinCount: 2, requiresCustomSymbol: true },
    { partType: "LED", pinCount: 2, requiresCustomSymbol: true },
    { partType: "Non-Polarized Capacitor", pinCount: 2 },
    { partType: "Film Capacitor", pinCount: 2 },
    { partType: "Ceramic Capacitor", pinCount: 2 },
    { partType: "Polarized Capacitor", pinCount: 2, requiresCustomSymbol: true },
    { partType: "Electrolytic Capacitor", pinCount: 2, requiresCustomSymbol: true },
    { partType: "Resistor", pinCount: 2 },
    { partType: "Fixed Resistor", pinCount: 2 },
];
/**
 * Helper function to check if a part should be unlabeled based on the criteria
 */
function isPartUnlabeled(partType, pinCount, hasCustomSymbol) {
    return exports.unlabeledPartCriteria.some((criterion) => {
        // Part type must match
        if (criterion.partType !== partType)
            return false;
        // If pin count is specified, it must match exactly
        if (criterion.pinCount !== undefined && criterion.pinCount !== pinCount)
            return false;
        // If custom symbol requirement is specified, it must match
        if (criterion.requiresCustomSymbol !== undefined && criterion.requiresCustomSymbol !== hasCustomSymbol)
            return false;
        return true;
    });
}
/**
 * @deprecated Use unlabeledPartCriteria instead
 * Part types that do not show pin labels in the schematic editor
 */
exports.unLabeledPartTypes = exports.unlabeledPartCriteria.map((criterion) => criterion.partType);
exports.copilotContextProperties = [
    "Domain",
    "Compliance",
    "Operating Voltage",
    "Operating Temperature",
    "Reliability Target (MTBF)",
    "Software",
    "Power Requirements",
    "Connectivity",
    "Human Interface",
];
exports.partPropertyCategories = {
    terminal: "Terminal",
    integratedCircuit: "Integrated Circuits",
    routeBranchPoint: "Route Branch Point",
    ground: "Ground",
};
/**
 * Standard electrical symbol pin mappings with aliases for fuzzy matching.
 * These define the predefined pin positions for standard Flux symbols.
 */
exports.STANDARD_SYMBOL_PIN_MAPPING = {
    Resistor: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in", "input"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out", "output"],
            },
        ],
    },
    "Fixed Resistor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in", "input"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out", "output"],
            },
        ],
    },
    Capacitor: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in", "vcc"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out", "gnd"],
            },
        ],
    },
    "Non-Polarized Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out"],
            },
        ],
    },
    "Polarized Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "+", "positive", "vcc", "anode"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "-", "negative", "gnd", "cathode"],
            },
        ],
    },
    Diode: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "anode", "in"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "k", "cathode", "out"],
            },
        ],
    },
    LED: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "anode", "+"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "k", "cathode", "-"],
            },
        ],
    },
    Inductor: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in", "input"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out", "output"],
            },
        ],
    },
    "Ceramic Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out"],
            },
        ],
    },
    "Film Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out"],
            },
        ],
    },
    "Silicon Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out"],
            },
        ],
    },
    "Electrolytic Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "+", "positive", "vcc", "anode"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "-", "negative", "gnd", "cathode"],
            },
        ],
    },
    "Super-cap Capacitor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "+", "positive", "vcc", "anode"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "-", "negative", "gnd", "cathode"],
            },
        ],
    },
    Ground: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: 0, y: 9.5 },
                aliases: ["1", "gnd", "ground"],
            },
        ],
    },
    Antenna: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: 0, y: 32.5 },
                aliases: ["1", "ant", "antenna", "rf"],
            },
        ],
    },
    Switch: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "in", "com", "common"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "out", "no", "normally open"],
            },
        ],
    },
    Relay: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -21, y: -32.5 },
                aliases: ["1", "coil+", "a1"],
            },
            {
                terminalNumber: "2",
                position: { x: -21, y: 32.5 },
                aliases: ["2", "coil-", "a2"],
            },
            {
                terminalNumber: "3",
                position: { x: 21, y: -32.5 },
                aliases: ["3", "com", "common"],
            },
            {
                terminalNumber: "4",
                position: { x: 21, y: 32.5 },
                aliases: ["4", "no", "normally open"],
            },
        ],
    },
    Transformer: {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -32.5, y: -32.5 },
                aliases: ["1", "p1", "primary1", "pri+"],
            },
            {
                terminalNumber: "2",
                position: { x: -32.5, y: 32.5 },
                aliases: ["2", "p2", "primary2", "pri-"],
            },
            {
                terminalNumber: "3",
                position: { x: 32.5, y: -32.5 },
                aliases: ["3", "s1", "secondary1", "sec+"],
            },
            {
                terminalNumber: "4",
                position: { x: 32.5, y: 32.5 },
                aliases: ["4", "s2", "secondary2", "sec-"],
            },
        ],
    },
    "Variable Resistor": {
        pins: [
            {
                terminalNumber: "1",
                position: { x: -16, y: 0 },
                aliases: ["1", "a", "ccw", "counter-clockwise"],
            },
            {
                terminalNumber: "2",
                position: { x: 16, y: 0 },
                aliases: ["2", "b", "cw", "clockwise"],
            },
            {
                terminalNumber: "3",
                position: { x: 0, y: -12.5 },
                aliases: ["3", "w", "wiper"],
            },
        ],
    },
};
/**
 * Returns the list of part types that have standard symbol pin mappings.
 * These part types will use predefined pin configurations and skip the pin configuration step in wizards.
 */
function getStandardSymbolPartTypes() {
    return Object.keys(exports.STANDARD_SYMBOL_PIN_MAPPING);
}
/**
 * Checks if a part type has a standard symbol pin mapping.
 * Part types with standard symbols will use predefined pin configurations.
 */
function hasStandardSymbol(partType) {
    if (!partType)
        return false;
    return partType in exports.STANDARD_SYMBOL_PIN_MAPPING;
}
/**
 * Mapping of part types to standard electrical symbol file paths.
 * These are the fallback symbols used when users haven't provided their own.
 *
 * Symbols are hosted on the CDN and referenced by their storage name.
 * FileStorage.getFileURL() prepends the CDN URL to these paths.
 */
exports.STANDARD_SYMBOL_MAPPING = {
    Resistor: "document_assets/fixed-resistor-us-9003be3c-a6c0-8314-d98f-a0a79124231c.svg",
    "Fixed Resistor": "document_assets/fixed-resistor-us-9003be3c-a6c0-8314-d98f-a0a79124231c.svg",
    Capacitor: "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Non-Polarized Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Polarized Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    Inductor: "document_assets/inductor-53001199-68ae-2ee6-e124-07e5ad151659.svg",
    Diode: "document_assets/pn-diode-70c00119-f94a-c7a3-366d-fc5366fcc570.svg",
    LED: "document_assets/led-off-e3f35236-6e8b-23a3-f491-751d2f88cf9c.svg",
    "Ceramic Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Film Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Silicon Capacitor": "document_assets/non-polarized-cap-63916ae4-4e5c-14be-af86-277996818cfc.svg",
    "Electrolytic Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    "Super-cap Capacitor": "document_assets/polarized-cap-37900753-12a8-31ba-520a-57d33f721c9b.svg",
    Ground: "document_assets/ground-420b199c-b591-be2b-99f1-088328ac6a43.svg",
    Antenna: "antenna-fbfac661-e562-f095-9591-586c8fa684ca.svg",
    Switch: "spst-switch-open-5840e219-0eab-cf67-6dab-9e43dcd1bf3b.svg",
    Relay: "document_assets/relay-off-5e60def9-837c-b6aa-cac8-38ff7eaa4456.svg",
    Transformer: "step-up-transformer-d72aafde-5b46-87da-cbd8-aab5368d1281.svg",
    "Variable Resistor": "potentiometer-45dbc4e3-09ec-74aa-b4dc-0c892202309b.svg",
};
// Define defaultPropertyDefinitionData first without a type, so that we get an object literal
// with explicit keys; then ensure its values are of type IDefaultProperty with the `satisfies`
// clause at the end; then export it as a Record with explicit keys and IDefaultProperty values.
// We need both those things to get good type checking and not require `!` property access.
//
// TODO: make const set of labels a type... those are the true "system properties"
const defaultPropertyDefinitionData = {
    // Project context properties
    part_type: {
        key: "part_type",
        label: "Part Type",
        auto_complete_options: Object.values(exports.partTypeAutocompleteOptions),
    },
    domain: {
        key: "domain",
        label: "Domain",
        auto_complete_options: [
            "Aerospace",
            "Agriculture",
            "Automotive",
            "Consumer Electronics",
            "Defense",
            "Energy",
            "Industrial/Manufacturing",
            "Marine",
            "Medical",
            "Scientific",
            "Telecommunications",
        ],
    },
    compliance: {
        key: "compliance",
        label: "Compliance",
        auto_complete_options: ["RoHS", "REACH", "DFARS", "Conflict Minerals (USA)", "AEC-Q100", "NiPdAu"],
    },
    jlcPcbPartClass: {
        key: "jlcPcbPartClass",
        label: "JLCPCB Part Class",
        auto_complete_options: ["Extended Part", "Basic Part"], // "Extended Part" means its on special order and therefore more expensive and time consuming to manufacture
    },
    // Performance properties
    operating_voltage: {
        key: "operating_voltage",
        label: "Operating Voltage",
        unit: "V",
        valueType: "number",
        auto_complete_options: ["3.3", "5", "9", "12", "20"],
    },
    operating_temp: {
        key: "operating_temp",
        label: "Operating Temperature",
    },
    target_mtbf: {
        key: "target_mtbf",
        label: "Reliability Target (MTBF)",
        unit: "hours",
        valueType: "number",
        auto_complete_options: ["10000", "30000", "50000"],
    },
    role: {
        key: "role",
        label: "Role",
        auto_complete_options: [
            "Decoupling",
            "Coupling",
            "Filtering",
            "Timing",
            "Bulk",
            "Pull Up / Down",
            "Current Limiting",
            "Voltage Division",
            "Biasing",
            "Snubber / Damping",
            "Impedance Matching",
            "Sensing (Shunt)",
            "Flyback / Freewheeling",
            "Reverse Polarity Protection",
            "Clamping",
            "Rectification",
            "Signal Mixing / Detection",
            "Logic-level Shifting",
            "Voltage Reference",
            "Power Filtering",
            "Choke (EMI Filter)",
            "Energy Storage",
            "RF Tuning / Matching",
            "Transformer Winding",
            "Amplification",
            "Switching",
            "Signal Generation",
            "Protection",
            "Isolation",
            "Modulation / Demodulation",
            "Feedback",
            "Debouncing",
            "Soft Start",
            "Phase Shifting",
            "Bootstrapping",
            "Latch",
            "Power Conversion",
        ].sort((a, b) => a.localeCompare(b)),
    },
    role_description: {
        key: "role_details",
        label: "Role Details",
        valueType: "string",
    },
    // Connectivity properties
    software: {
        key: "software",
        label: "Software",
        auto_complete_options: ["Arduino", "Linux", "Bare metal"],
    },
    connector_type: {
        key: "connector_type",
        label: "Connector Type",
        auto_complete_options: [
            "Audio / Video Connectors",
            "Automotive Connectors",
            "Backplane Connectors",
            "Board to Board Connectors",
            "Card Edge Connectors",
            "Circular Connectors",
            "D-Sub Connectors",
            "FFC / FPC",
            "Fiber Optic Connectors",
            "Headers and Wire Housings",
            "IC and Component Sockets",
            "Memory Connectors",
            "Modular / Ethernet Connectors",
            "Photovoltaic / Solar Connectors",
            "Power Connectors",
            "RF / Coaxial Connectors",
            "Terminal Blocks",
            "Terminals",
            "USB Connectors",
        ],
    },
    connector_gender: {
        key: "connector_gender",
        label: "Connector Gender",
        auto_complete_options: [
            "Male",
            "Female",
            "Receptacle",
            "Female to Female",
            "Female to Male",
            "Hermaphroditic",
            "Non-Gendered",
        ],
    },
    connector_pitch: {
        key: "connector_pitch",
        label: "Connector Pitch",
        unit: "mm",
        valueType: "number",
    },
    connector_positions: {
        key: "connector_positions",
        label: "Connector Positions",
    },
    connector_rows: {
        key: "connector_rows",
        label: "Connector Rows",
    },
    power_requirements: {
        key: "power_requirements",
        label: "Power Requirements",
        auto_complete_options: ["USB", "Battery", "Mains", "Power-over-Ethernet"],
    },
    connectivity: {
        key: "connectivity",
        label: "Connectivity",
        auto_complete_options: ["WiFi", "Bluetooth", "Cellular", "Ethernet", "USB"],
    },
    human_interface: {
        key: "human_interface",
        label: "Human Interface",
        auto_complete_options: ["Touchscreen", "Buttons", "Switches", "Rotary encoder", "Joystick", "Display"],
    },
    // Manufacturing/part sourcing properties
    manufacturing_quantity_target: {
        key: "manufacturing_quantity_target",
        label: "Manufacturing Quantity Target",
        valueType: "number",
        auto_complete_options: ["1", "5", "10", "25", "50", "100", "500", "1000", "10000"],
        tags: ["pricing"],
    },
    mpn: { key: "mpn", label: "Manufacturer Part Number" },
    lcsc_dpn: { key: "lcsc_dpn", label: "LCSC Part Number" },
    digikey_dpn: { key: "digikey_dpn", label: "Digi-Key Part Number" },
    mouser_dpn: { key: "mouser_dpn", label: "Mouser Part Number" },
    arrow_dpn: { key: "arrow_dpn", label: "Arrow Part Number" },
    verical_dpn: { key: "verical_dpn", label: "Verical Part Number" },
    tme_dpn: { key: "tme_dpn", label: "TME Part Number" },
    allow_substitutes: { key: "allow_substitutes", label: "Allow Substitutes", auto_complete_options: ["Yes", "No"] },
    manufacturer_name: {
        key: "manufacturer_name",
        label: "Manufacturer Name",
        // For complete lists from distributors, see mouserManufacturerList, digikeyManufacturerList, lcscManufacturerList.
        auto_complete_options: semiconductorManufacturerAliases_1.semiconductorManufacturerAliases
            .map((manufacturer) => manufacturer.name)
            .sort((a, b) => a.localeCompare(b)),
    },
    price_change_threshold: {
        key: "price_change_threshold",
        label: "Price Change Threshold",
        valueType: "number",
        unit: "%",
        auto_complete_options: ["1", "3", "5", "10"],
        tags: ["pricing"],
    },
    lead_time_change_threshold: {
        key: "lead_time_change_threshold",
        label: "Lead Time Change Threshold",
        valueType: "number",
        unit: "%",
        auto_complete_options: ["0", "3", "5"],
        tags: ["pricing"],
    },
    pricing_notification_frequency: {
        key: "pricing_notification_frequency",
        label: "Pricing Notification Frequency",
        auto_complete_options: ["weekly", "monthly", "quarterly", "off"],
        tags: ["pricing"],
    },
    preferred_distributors: {
        key: "preferred_distributors",
        label: "Preferred Distributors",
        // NOTE: keep this in sync with MPNRecord.distributorName and DistributorIdentifierEnum
        auto_complete_options: ["LCSC", "Digi-Key", "Mouser", "Arrow", "Verical", "TME"],
        tags: ["pricing"],
    },
    datasheet_url: {
        key: "datasheet_url",
        label: "Datasheet URL",
        valueType: "link",
    },
    designator_prefix: {
        key: "designator_prefix",
        label: "Designator Prefix",
        exclude_from_bom: true,
    },
    license_type: {
        key: "license_type",
        label: "License",
        auto_complete_options: [
            "http://solderpad.org/licenses/SHL-2.1/",
            "https://www.gnu.org/licenses/gpl-3.0.html",
            "https://creativecommons.org/licenses/by/4.0/",
            "https://ohwr.org/project/cernohl/wikis/home",
            "https://tapr.org/the-tapr-open-hardware-license/",
        ],
    },
    package_case_code: {
        key: "package_case_code",
        label: "Package or Case Code",
        // Uses PACKAGE_CASE_CODE_DATA as the source of truth
        // Sorted by family first, then by pin count within each family for better UI display
        auto_complete_options: getPackageCaseCodeOptions(),
    },
    symbol_pin_position: {
        key: "symbol_pin_position",
        label: "Symbol Pin Position",
        valueType: "vector2",
        type: PropertyTypes.symbolPinPosition,
        exclude_from_bom: true,
    },
    pin_number: {
        key: "pin_number",
        label: "Pin Number",
        valueType: "number",
        type: PropertyTypes.pinNumber,
        exclude_from_bom: true,
    },
    pin_group: {
        key: "pin_group",
        label: "Pin Group",
        valueType: "string",
        dynamic_auto_complete: true,
        auto_complete_options: [
            "GPIOA",
            "GPIOB",
            "GPIOC",
            "PA",
            "PB",
            "PC",
            "PORTA",
            "PORTB",
            "SPI",
            "I2C",
            "UART",
            "USART",
            "CAN",
            "USB",
            "Address Bus",
            "Data Bus",
            "Control Bus",
            "ADDR",
            "DATA",
            "TIM",
            "Timer",
            "PWM",
            "Counter",
            "ADC",
            "DAC",
            "Analog",
            "Comparator",
            "Reference",
            "VCC",
            "GND",
            "VDD",
            "VSS",
            "Power",
            "Ground",
            "CLK",
            "XTAL",
            "Oscillator",
            "Crystal",
            "JTAG",
            "SWD",
            "Debug",
            "Boot",
        ],
        exclude_from_bom: true,
    },
    pin_orientation: {
        key: "pin_orientation",
        label: "Pin Orientation",
        valueType: "string",
        // Options will include "up", "down" in future, but currently only "left" and "right" are implemented
        auto_complete_options: ["Left", "Right"],
        exclude_from_bom: true,
    },
    section: {
        key: "section",
        label: "Section",
        valueType: "string",
        dynamic_auto_complete: true,
        auto_complete_options: [
            "Power",
            "PWR",
            "Power Supply",
            "Voltage Regulator",
            "Control",
            "Reset",
            "Clock",
            "Enable",
            "Communication",
            "Interface",
            "Serial",
            "Parallel",
            "Data",
            "Processing",
            "CPU",
            "Logic",
            "Analog",
            "ADC",
            "DAC",
            "Sensors",
            "GPIO",
            "Digital I/O",
            "General Purpose",
            "Peripheral",
            "External",
            "Expansion",
            "MISC",
            "Miscellaneous",
            "Other",
            "Debug",
        ],
        exclude_from_bom: true,
    },
    // `terminal_type` is deprecated -- use pin_type instead
    terminal_type: { key: "terminal_type", label: "Terminal Type" },
    terminal_order: {
        key: "terminal_order",
        label: "Terminal Order",
        exclude_from_bom: true,
        valueType: "number",
    },
    pin_type: {
        key: "pin_type",
        label: "Pin Type",
        // NOTE: terminal.type is derived from pin_type
        auto_complete_options: exports.pinTypeOptions,
    },
    voltage: {
        key: "voltage",
        label: "Voltage",
        // QUESTION: what does it mean for a property to have a unit but not a valueType of "number"?
        unit: "V",
    },
    voltage_rating: {
        key: "voltage_rating",
        label: "Voltage Rating",
        unit: "V",
        valueType: "number",
    },
    forward_voltage: {
        key: "forward_voltage",
        label: "Forward Voltage",
        unit: "V",
        valueType: "number",
    },
    reverse_voltage: {
        key: "reverse_voltage",
        label: "Reverse Voltage",
        unit: "V",
        valueType: "number",
    },
    max_reverse_voltage: {
        key: "max_reverse_voltage",
        label: "Max Reverse Voltage",
        unit: "V",
        valueType: "number",
    },
    diode_type: {
        key: "diode_type",
        label: "Diode Type",
        auto_complete_options: ["Zener", "Schottky", "Rectifier", "LED", "Varactor", "Tunnel", "PIN"],
    },
    mount_type: {
        key: "mount_type",
        label: "Mount",
        auto_complete_options: ["Surface Mount", "Through Hole"],
    },
    integrated_circuit_type: {
        key: "integrated_circuit_type",
        label: "Integrated Circuit Type",
        auto_complete_options: [
            "Clock and Timing",
            "Data Converter",
            "Embedded Processor",
            "Embedded Controller",
            "Linear",
            "Logic",
            "Memory",
            "Power Management",
            "RF Semiconductor",
            "RF Device",
            "FPGA",
        ],
    },
    breakdown_voltage: {
        key: "breakdown_voltage",
        label: "Breakdown Voltage",
        unit: "V",
        valueType: "number",
    },
    threshold_voltage: {
        key: "threshold_voltage",
        label: "Threshold Voltage",
        unit: "V",
        valueType: "number",
    },
    max_out_voltage: {
        key: "max_out_voltage",
        label: "Max Output Voltage",
        unit: "V",
        valueType: "number",
    },
    min_out_voltage: {
        key: "min_out_voltage",
        label: "Max Input Voltage",
        unit: "V",
        valueType: "number",
    },
    initial_voltage_on_reset: {
        key: "initial_voltage_on_reset",
        label: "Initial Voltage on Reset",
        unit: "V",
        valueType: "number",
    },
    resistance: {
        key: "resistance",
        label: "Resistance",
        unit: "Ω",
        type: PropertyTypes.value,
        valueType: "number",
    },
    resistor_type: {
        key: "resistor_type",
        label: "Resistor Type",
        auto_complete_options: [
            "Chip SMD",
            "Array",
            "Network",
            "Thermistor",
            "Through-Hole",
            "Variable",
            "Potentiometer",
            "Wirewound",
        ],
    },
    gate_resistance: {
        key: "gate_resistance",
        label: "Gate Resistance",
        unit: "Ω",
        valueType: "number",
    },
    on_resistance: {
        key: "on_resistance",
        label: "On Resistance",
        unit: "Ω",
        valueType: "number",
    },
    off_resistance: {
        key: "off_resistance",
        label: "Off Resistance",
        unit: "Ω",
        valueType: "number",
    },
    tolerance: {
        key: "tolerance",
        label: "Tolerance",
        unit: "%",
        valueType: "number",
    },
    capacitance: {
        key: "capacitance",
        label: "Capacitance",
        unit: "F",
        type: PropertyTypes.value,
        valueType: "number",
    },
    capacitor_type: {
        key: "capacitor_type",
        label: "Capacitor Type",
        auto_complete_options: [
            "Aluminum Electrolytic",
            "Array",
            "Ceramic",
            "Film",
            "Mica",
            "Polymer",
            "Tantalum",
            "Trimmer",
            "Variable",
        ],
    },
    power: {
        key: "power",
        label: "Power",
        unit: "W",
        valueType: "number",
    },
    power_rating: {
        key: "power_rating",
        label: "Power Rating",
        unit: "W",
        valueType: "number",
    },
    current: {
        key: "current",
        label: "Current",
        unit: "A",
        valueType: "number",
        isPreset: true,
    },
    max_current: {
        key: "max_current",
        label: "Max Current",
        unit: "A",
        valueType: "number",
        isPreset: true,
    },
    desiredTemperatureRise: {
        key: "desiredTemperatureRise",
        label: "Desired Temperature Rise",
        unit: "C",
        valueType: "number",
    },
    current_rating: {
        key: "current_rating",
        label: "Current Rating",
        unit: "A",
        valueType: "number",
    },
    leakage_current: {
        key: "leakage_current",
        label: "Leakage Current",
        unit: "A",
        valueType: "number",
    },
    saturation_current: {
        key: "saturation_current",
        label: "Saturation Current",
        unit: "A",
        valueType: "number",
    },
    initial_current_on_reset: {
        key: "initial_current_on_reset",
        label: "Initial Current on Reset",
        unit: "A",
        valueType: "number",
    },
    trigger_current: {
        key: "trigger_current",
        label: "Trigger Current",
        unit: "A",
        valueType: "number",
    },
    holding_current: {
        key: "holding_current",
        label: "Holding Current",
        unit: "A",
        valueType: "number",
    },
    frequency: {
        key: "frequency",
        label: "Frequency",
        unit: "Hz",
        valueType: "number",
    },
    logic_function: {
        key: "logic_function",
        label: "Logic Function",
        auto_complete_options: [
            "AND",
            "OR",
            "NAND",
            "NOR",
            "XOR",
            "XNOR",
            "NOT",
            "Buffer",
            "Driver",
            "Regulator",
            "Timer",
            "Inverting",
            "Schmitt Trigger",
            "D-Type",
            "JK-Type",
            "Receiver",
            "Inverter",
            "Multiplexer",
            "Flip-Flop",
            "Latch",
            "Demultiplexer",
            "Counter",
            "Shift Register",
            "Translator",
            "Decoder",
            "Clock",
            "Mux",
            "Multivibrator",
            "Demux",
            "Multi Function",
            "Level Shifter",
            "Binary Full Adder",
            "Parity Gen",
            "Configurable",
            "Storage",
            "Control Unit",
            "Monitor",
            "Amplifier",
        ],
    },
    inductance: {
        key: "inductance",
        label: "Inductance",
        unit: "H",
        type: PropertyTypes.value,
    },
    inductor_shielding: {
        key: "inductor_shielding",
        label: "Inductor Shielding",
        auto_complete_options: ["Shielded", "Unshielded"],
    },
    inductor_type: {
        key: "inductor_type",
        label: "Inductor Type",
        auto_complete_options: ["Fixed", "Variable"],
    },
    beta: {
        key: "beta",
        label: "Beta",
    },
    drain_to_source_voltage: {
        key: "drain_to_source_voltage",
        label: "Drain to Source Voltage",
        unit: "V",
    },
    continuous_drain_current: {
        key: "continuous_drain_current",
        label: "Continuous Drain Current",
        unit: "A",
    },
    transistor_type: {
        key: "transistor_type",
        label: "Transistor Type",
        auto_complete_options: ["BJT", "IGBT", "JFET", "MOSFET", "NPN"],
    },
    gain: {
        key: "gain",
        label: "Gain",
    },
    coupling_coefficient: {
        key: "coupling_coefficient",
        label: "Coupling Coefficient",
    },
    ratio: {
        key: "ratio",
        label: "Ratio",
    },
    reference_design_url: { key: "reference_design_url", label: "Reference Design URL" },
    single_unit_price: { key: "single_unit_price", label: "Price", unit: "$" },
    purchase_url: { key: "purchase_url", label: "Purchase Url" },
    product_info_url: { key: "product_info_url", label: "Product Info Url" },
    product_image_url: { key: "product_image_url", label: "Product Image Url" },
    substitute_mpn: {
        key: "substitute_mpn",
        label: "Substitute Manufacturer Part Number",
    },
    kicad_library_reference: {
        key: "kicad_library_reference",
        label: "KiCAD Library Reference",
    },
    kicad_component_orientation_offset: {
        key: "kicad_component_orientation_offset",
        label: "KiCAD Orientation Offset",
        unit: "°",
        exclude_from_bom: true,
    },
    edif_instance_ref: {
        key: "edif_instance_ref",
        label: "EDIF instanceRef",
        exclude_from_bom: true,
    },
    edif_net_name: {
        key: "edif_net_name",
        label: "EDIF Net Name",
        exclude_from_bom: true,
    },
    exclude_from_bom: {
        key: "exclude_from_bom",
        label: "Exclude from BOM",
        auto_complete_options: ["true", "false"],
        exclude_from_bom: true,
    },
    exclude_from_pcb: {
        key: "exclude_from_pcb",
        label: "Exclude from PCB",
        auto_complete_options: ["true", "false"],
        // QUESTION: is exclude_from_pcb used anywhere?
        exclude_from_pcb: true,
    },
    // Impedance Control
    controlled_impedance: {
        key: "controlled_impedance",
        label: "Controlled Impedance",
        valueType: "number",
        unit: "Ω",
    },
    controlled_impedance_tolerance: {
        key: "controlled_impedance_tolerance",
        label: "Controlled Impedance Tolerance",
        valueType: "string",
        unit: "%",
    },
    positive_to_negative_skew_max: {
        key: "positive_to_negative_skew_max",
        label: "PN Skew Max",
        valueType: "string",
        unit: "ps",
    },
    pair_to_pair_skew_max: {
        key: "pair_to_pair_skew_max",
        label: "Pair to Pair Skew Max",
        valueType: "string",
        unit: "ps",
    },
    pin_delay: {
        key: "pin_delay",
        label: "Pin Delay",
        valueType: "number",
        unit: "ps",
    },
    controlled_impedance_pair: {
        key: "controlled_impedance_pair",
        label: "Controlled Impedance Pair",
        valueType: "string",
        dynamic_auto_complete: true,
    },
    bus_group: {
        key: "bus_group",
        label: "Bus Group",
        valueType: "string",
        dynamic_auto_complete: true,
        auto_complete_options: [
            "SPI Bus",
            "I2C Bus",
            "UART Bus",
            "CAN Bus",
            "Data Bus",
            "Address Bus",
            "Control Bus",
            "DDR",
            "SDRAM",
            "Flash",
            "EEPROM",
            "HDMI",
            "VGA",
            "LCD",
            "MIPI",
            "PCIe",
            "USB",
            "Ethernet",
            "SATA",
            "AHB",
            "APB",
            "AXI",
            "Wishbone",
        ],
    },
    pair_role: {
        key: "pair_role",
        label: "Pair Role",
        valueType: "string",
        auto_complete_options: [
            "CLK",
            "D0",
            "D1",
            "D2",
            "D3",
            "D4",
            "TX",
            "TX1",
            "TX2",
            "TX3",
            "RX",
            "RX1",
            "RX2",
            "RX3",
        ],
    },
    pin_role: {
        key: "pin_role",
        label: "Pin Role",
        valueType: "string",
        auto_complete_options: ["CLK", "MOSI", "MISO", "SCL", "CS", "SDA", "TX", "RX"],
    },
    bus_type: {
        key: "bus_type",
        label: "Bus Type",
        auto_complete_options: [
            "DDR2",
            "DDR3",
            "DDR4",
            "HDMI",
            "MIPI CSI",
            "MIPI DSI",
            "PCIe 2.0",
            "PCIe 3.0",
            "PCIe 4.0",
            "USB 2.0",
            "USB 3.0",
            "SPMI",
            "SPI",
            "I2C",
            "UART",
            "Ethernet",
        ],
    },
    symbol_style: {
        key: "symbol_style",
        label: "Symbol Style",
        auto_complete_options: ["Legacy", "Parametric"],
    },
    symbol_size: {
        key: "symbol_size",
        label: "Symbol Size",
        valueType: "vector2",
    },
    subsymbol_designator_suffix: {
        key: "subsymbol_designator_suffix",
        label: "Sub-symbol Designator Suffix",
        valueType: "string",
        dynamic_auto_complete: true,
        auto_complete_options: [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "Main",
            "Power",
            "Analog",
            "Digital",
            "Interface",
            "Section1",
            "Section2",
            "Part1",
            "Part2",
            "MAIN",
        ],
        exclude_from_bom: true,
    },
    net_type: {
        key: "net_type",
        label: "Net Type",
        valueType: "string",
        auto_complete_options: ["Power", "High Speed", "Medium Speed", "Low Speed", "Analog", "Ground"],
        isPreset: true,
    },
};
// The above definition results in a type with has explicit keys (part_type, domain, symbol_style etc) but
// literal objects for values instead of IDefaultProperty. Below, we export it as a Record with both explicit
// keys, and IDefaultProperty values, so TypeScript will catch misuse (and still not require `!` access)
exports.defaultPropertyDefinitions = defaultPropertyDefinitionData;
exports.propertyDefinitionsByLabel = (0, lodash_1.mapKeys)(exports.defaultPropertyDefinitions, "label");
//# sourceMappingURL=property.js.map